import {
	codeCTAValidatorSchema,
	doubleLinkCTAValidatorSchema,
	eventCTAValidatorSchema,
	linkCTAValidatorSchema,
	offerCTAValidatorSchema,
	suggestedReplyValidatorSchema,
} from '@app/utils/modules/actions/schemas';

export const TitleFallback = 'Click to learn more';

export enum CTAListEnum {
	link = 'linkCta',
	text = 'textCta',
	code = 'codeCta',
	date = 'dateCta',
	shop = 'shopifyCta',
	doubleLink = 'doubleLinkCta',
	event = 'eventCta',
	suggestedReply = 'suggestedReplyCta',
	offer = 'offerCta',
}

export enum CTANameListEnum {
	linkCta = 'Link',
	textCta = 'Text',
	codeCta = 'Code',
	shopifyCta = 'Shopify',
	doubleLinkCta = 'Double link',
	eventCta = 'Event',
	suggestedReplyCta = 'Suggested Reply',
	offerCta = 'Offer',
}

export const CTASchemas = {
	[CTAListEnum.link]: linkCTAValidatorSchema,
	[CTAListEnum.doubleLink]: doubleLinkCTAValidatorSchema,
	[CTAListEnum.code]: codeCTAValidatorSchema,
	[CTAListEnum.suggestedReply]: suggestedReplyValidatorSchema,
	[CTAListEnum.event]: eventCTAValidatorSchema,
	[CTAListEnum.offer]: offerCTAValidatorSchema,
};
